import AnalyticFeedsIcon from '@apps-common/ui-icons/AnalyticFeeds.jsx';
import BasemapViewerIcon from '@apps-common/ui-icons/BasemapViewer.jsx';
import ExplorerIcon from '@apps-common/ui-icons/Explorer.jsx';
import React from 'react';
import SentinelHubIcon from '@apps-common/ui-icons/Sentinelhub.jsx';
import SinergiseIcon from '@apps-common/ui-icons/Sinergise.jsx';
import StoriesIcon from '@apps-common/ui-icons/Stories.jsx';
import TaskingIcon from '@apps-common/ui-icons/TaskingDashboard.jsx';
import {
  RocketLaunchOutlined as AccountAppIcon,
  AutoAwesomeMosaic,
  CodeOutlined,
  DashboardCustomizeOutlined as DataAppIcon,
  AddLocationAltOutlined as FeaturesManagerIcon,
  Language,
  MediationOutlined,
  StorageOutlined,
  TextSnippetOutlined,
} from '@mui/icons-material';
import {Analyze, ConfigurationManager} from '@apps-common/ui-icons';

import AccountAppLogo from './Logo/AccountAppLogo.jsx';
import AnalyzeAppLogo from './Logo/AnalyzeAppLogo.jsx';
import DataAppLogo from './Logo/DataAppLogo.jsx';

/**
 * All of the environments should use production auth and apis. This would allow us to
 * do end to end tests across the platform. Handling of staging auth and apis should be
 * accomodated by every app individually when needed.
 */
export const ENVIRONMENTS = {
  staging: 'staging',
  production: 'production',
};

export const APPS = {
  // Top Nav
  account: {
    title: 'Account',
    href: {
      [ENVIRONMENTS.staging]:
        'https://static.prod.planet-labs.com/account-manager/staging/',
    },
    icon: AccountAppIcon,
    logo: size => <AccountAppLogo size={size} />,
  },
  data: {
    title: 'Data',
    href: {
      [ENVIRONMENTS.staging]:
        'https://static.prod.planet-labs.com/acorns/main/',
    },
    icon: DataAppIcon,
    logo: size => <DataAppLogo size={size} />,
  },
  analyze: {
    title: 'Analyze',
    href: {
      [ENVIRONMENTS.staging]:
        'https://static.prod.planet-labs.com/pip-browser/staging/',
    },
    icon: Analyze,
    logo: size => <AnalyzeAppLogo size={size} />,
  },

  welcomePage: {
    title: 'Welcome',
    href: {
      [ENVIRONMENTS.staging]:
        'https://static.prod.planet-labs.com/pip-welcome-page/staging/',
    },
  },
  explorer: {
    title: 'Explorer',
    href: {
      [ENVIRONMENTS.staging]:
        'https://static.prod.planet-labs.com/explorer/live/pipped-explorer/',
      [ENVIRONMENTS.production]: 'https://www.planet.com/explorer/',
    },
    icon: ExplorerIcon,
  },
  featuresManager: {
    title: 'Features Manager',
    href: {
      [ENVIRONMENTS.staging]:
        'https://static.prod.planet-labs.com/features-manager/live/pipped-fm/',
      [ENVIRONMENTS.production]: 'https://www.planet.com/features/',
    },
    icon: FeaturesManagerIcon,
  },
  dataManagerOverview: {
    title: 'Overview',
    href: {
      [ENVIRONMENTS.staging]:
        'https://static.prod.planet-labs.com/acorns/main/overview/',
    },
    icon: AutoAwesomeMosaic,
  },
  dataManagerOrders: {
    title: 'Orders',
    href: {
      [ENVIRONMENTS.staging]:
        'https://static.prod.planet-labs.com/acorns/main/orders/',
    },
    icon: TextSnippetOutlined,
  },
  dataManagerSubscriptions: {
    title: 'Subscriptions',
    href: {
      [ENVIRONMENTS.staging]:
        'https://static.prod.planet-labs.com/acorns/main/subscriptions/',
    },
    icon: MediationOutlined,
  },
  dataCollections: {
    title: 'Data Collections',
    href: {
      [ENVIRONMENTS.staging]:
        'https://static.prod.planet-labs.com/data-manager/staging/',
    },
    icon: StorageOutlined,
  },
  browser: {
    title: 'Browser',
    href: {
      [ENVIRONMENTS.staging]:
        'https://static.prod.planet-labs.com/pip-browser/staging/',
    },
    icon: Language,
  },
  configurationManager: {
    title: 'Configurations',
    href: {
      [ENVIRONMENTS.staging]:
        'https://static.prod.planet-labs.com/config-manager/staging/',
    },
    icon: ConfigurationManager,
  },
  requestsBuilder: {
    title: 'Requests Builder',
    href: {
      [ENVIRONMENTS.staging]:
        'https://static.prod.planet-labs.com/requests-builder/master/',
    },
    icon: CodeOutlined,
  },

  // Planet Apps
  tasking: {
    title: 'Tasking Dashboard',
    href: {
      [ENVIRONMENTS.staging]:
        'https://static.prod.planet-labs.com/om-web/prod/',
      [ENVIRONMENTS.production]: 'https://www.planet.com/tasking/',
    },
    icon: TaskingIcon,
  },
  stories: {
    title: 'Stories',
    href: {
      [ENVIRONMENTS.staging]:
        'https://static.prod.planet-labs.com/stories/main/',
      [ENVIRONMENTS.production]: 'https://www.planet.com/stories/',
    },
    icon: StoriesIcon,
  },
  basemapsViewer: {
    title: 'Basemaps Viewer',
    href: {
      [ENVIRONMENTS.staging]:
        'https://static.prod.planet-labs.com/mosaics/main/',
      [ENVIRONMENTS.production]: 'https://www.planet.com/basemaps/',
    },
    icon: BasemapViewerIcon,
  },
  feedsViewer: {
    title: 'Analytic Feeds',
    href: {
      [ENVIRONMENTS.staging]:
        'https://static.prod.planet-labs.com/feeds/live/main/',
      [ENVIRONMENTS.production]: 'https://www.planet.com/feeds/',
    },
    icon: AnalyticFeedsIcon,
  },
};

// Temporary for migration
export const LEGACY_SH_APPS = [
  {
    title: 'Sentinel Hub Dashboard',
    subtitle:
      'Manage your Sentinel Hub account, collections, and monitor usage',
    href: {
      [ENVIRONMENTS.staging]: 'https://apps.sentinel-hub.com/dashboard/',
      [ENVIRONMENTS.production]: 'https://apps.sentinel-hub.com/dashboard/',
    },
    icon: SentinelHubIcon,
    id: 'sentinelhub',
  },
  {
    title: 'EO Browser',
    subtitle: 'Browse and compare images',
    href: {
      [ENVIRONMENTS.production]: 'https://apps.sentinel-hub.com/eo-browser/',
      [ENVIRONMENTS.staging]: 'https://apps.sentinel-hub.com/eo-browser/',
    },
    icon: SinergiseIcon,
    id: 'eobrowser',
  },
];
